(function () {
  let controller = null;

  /*
   * bureau bravo 22.09.2026: Fallback-Text, falls die Anzahl nicht ermittelt werden kann
   * (Netzwerkfehler, Markup ohne Zähl-Element). Vorher blieb "Produkte werden geladen …" stehen.
   */
  const FALLBACK_TEXT = "Filter anwenden";

  /**
   * ---------------------------------------------------------
   * FILTER PRODUKTANZAHL
   * ---------------------------------------------------------
   */

  function getButton(form) {
    return form?.querySelector(
      "button[is='facet-apply-button']"
    );
  }

  function getCountElement(button) {
    return (
      button?.filterCountElement ||
      button?.querySelector("span")
    );
  }

  function setButtonText(button, text) {
    if (!button) return;

    const countElement = getCountElement(button);

    if (!countElement) return;

    countElement.textContent = ` ${text}`;
  }

  function getProductCount(form) {
    if (
      !form ||
      typeof form._buildUrl !== "function"
    ) {
      return;
    }

    const button = getButton(form);

    if (!button) {
      return;
    }

    setButtonText(
      button,
      "Produkte werden geladen …"
    );

    if (controller) {
      controller.abort();
    }

    controller = new AbortController();

    let url;

    try {
      url = form._buildUrl();
    } catch (error) {
      console.error(
        "Fehler beim Erstellen der Filter-URL:",
        error
      );
      return;
    }

    fetch(url.toString(), {
      signal: controller.signal,
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            `HTTP ${response.status}`
          );
        }

        return response.text();
      })
      .then(function (html) {
        const doc =
          new DOMParser().parseFromString(
            html,
            "text/html"
          );

        const countElement =
          doc.querySelector(
            "[data-filter-product-count]"
          );

        if (!countElement) {
          console.warn(
            "Produktanzahl nicht gefunden."
          );
          setButtonText(getButton(form), FALLBACK_TEXT);
          return;
        }

        const count =
          countElement.textContent.trim();

        if (!count) {
          setButtonText(getButton(form), FALLBACK_TEXT);
          return;
        }

        /*
         * Prüfen, ob der Button inzwischen noch
         * zum aktuellen Formular gehört.
         */
        const currentButton =
          getButton(form);

        if (!currentButton) {
          return;
        }

        setButtonText(
          currentButton,
          `${count} Produkte anzeigen`
        );
      })
      .catch(function (error) {
        if (error.name === "AbortError") {
          return;
        }

        console.error(
          "Fehler beim Ermitteln der Produktanzahl:",
          error
        );
        setButtonText(getButton(form), FALLBACK_TEXT);
      });
  }


  /**
   * ---------------------------------------------------------
   * BUTTON INITIALISIEREN
   * ---------------------------------------------------------
   */

  function initializeForm(form) {
    if (!form) {
      return;
    }

    const button = getButton(form);

    if (!button) {
      return;
    }

    /*
     * Verhindert unnötige doppelte Initialisierung.
     */
    if (button.dataset.productCountInitialized === "true") {
      return;
    }

    button.dataset.productCountInitialized = "true";

    /*
     * bureau bravo 22.09.2026: Beim Seitenaufruf steht die Anzahl bereits im Formular
     * ([data-filter-product-count] aus facets-vertical.liquid). Nur wenn sie fehlt,
     * wird nachgeladen; vorher löste jeder Seitenaufruf einen zusätzlichen Request aus.
     */
    const ownCountElement = form.querySelector(
      "[data-filter-product-count]"
    );
    const ownCount = ownCountElement
      ? ownCountElement.textContent.trim()
      : "";

    if (ownCount) {
      setButtonText(button, `${ownCount} Produkte anzeigen`);
      return;
    }

    getProductCount(form);
  }


  /**
   * ---------------------------------------------------------
   * IMPACT FILTER APPLY BUTTON
   * ---------------------------------------------------------
   *
   * Impact schreibt normalerweise "(1)", "(2)" usw.
   * in den Button.
   *
   * Das deaktivieren wir, weil wir dort stattdessen
   * "X Produkte anzeigen" verwenden.
   */

  function disableImpactCount() {
    const FacetApplyButton =
      customElements.get(
        "facet-apply-button"
      );

    if (!FacetApplyButton) {
      return;
    }

    FacetApplyButton.prototype._updateCount =
      function () {
        // Bewusst deaktiviert.
        // Wir zeigen stattdessen die Produktanzahl.
      };
  }


  /**
   * ---------------------------------------------------------
   * FILTERÄNDERUNG
   * ---------------------------------------------------------
   */

  function setupChangeListener() {
    document.addEventListener(
      "change",
      function (event) {
        const form =
          event.target.closest(
            "form[is='facet-form']"
          );

        if (!form) {
          return;
        }

        const button = getButton(form);

        if (button) {
          setButtonText(
            button,
            "Produkte werden geladen …"
          );
        }

        /*
         * Kleine Verzögerung, damit Impact seine
         * Filterdaten aktualisieren kann.
         */
        requestAnimationFrame(function () {
          getProductCount(form);
        });
      },
      true
    );
  }


  /**
   * ---------------------------------------------------------
   * DYNAMISCH NEU ERZEUGTE FILTER ERKENNEN
   * ---------------------------------------------------------
   *
   * Impact ersetzt beim Öffnen/Schließen bzw. beim
   * Aktualisieren Teile des Filters.
   *
   * Deshalb beobachten wir nur neu hinzugefügte Elemente.
   *
   * Wichtig:
   * Wir beobachten NICHT characterData.
   * Dadurch entsteht keine Endlosschleife,
   * wenn wir den Button-Text ändern.
   */

  function setupMutationObserver() {
    const observer =
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(
            function (node) {
              if (
                node.nodeType !==
                Node.ELEMENT_NODE
              ) {
                return;
              }

              /*
               * Falls direkt ein Filterformular
               * hinzugefügt wurde.
               */
              if (
                node.matches?.(
                  "form[is='facet-form']"
                )
              ) {
                initializeForm(node);
              }

              /*
               * Falls ein Filterformular innerhalb
               * des hinzugefügten Elements liegt.
               */
              node
                .querySelectorAll?.(
                  "form[is='facet-form']"
                )
                .forEach(function (form) {
                  initializeForm(form);
                });
            }
          );
        });
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /**
   * ---------------------------------------------------------
   * START
   * ---------------------------------------------------------
   */

  function start() {
    disableImpactCount();

    /*
     * Bereits vorhandene Formulare initialisieren.
     */
    document
      .querySelectorAll(
        "form[is='facet-form']"
      )
      .forEach(function (form) {
        initializeForm(form);
      });

    setupChangeListener();
    setupMutationObserver();
  }


  /*
   * Warten, bis Impact das Custom Element registriert.
   */
  if (
    customElements.get(
      "facet-apply-button"
    )
  ) {
    start();
  } else {
    customElements
      .whenDefined(
        "facet-apply-button"
      )
      .then(start);
  }
})();


/**
 * ---------------------------------------------------------
 * PRODUKTGALERIE
 * ---------------------------------------------------------
 *
 * Pfeil am Rand + normaler Mauszeiger
 */

document.addEventListener(
  "pointermove",
  function (event) {
    const cursor =
      document.querySelector(
        ".product-gallery__cursor"
      );

    if (!cursor) return;

    const gallery =
      cursor.parentElement;

    if (!gallery) return;

    const rect =
      gallery.getBoundingClientRect();

    /*
     * Normalen Mauszeiger anzeigen
     */
    gallery.style.cursor = "default";

    /*
     * Custom-Pfeil darf Mauszeiger nicht blockieren
     */
    cursor.style.pointerEvents = "none";

    /*
     * Pfeil vertikal zentrieren
     */
    cursor.style.setProperty(
      "top",
      "50%",
      "important"
    );

    cursor.style.setProperty(
      "transform",
      "translateY(-50%)",
      "important"
    );

    cursor.style.setProperty(
      "translate",
      "0 0",
      "important"
    );

    /*
     * Pfeil links oder rechts
     */
    if (
      event.clientX <
      rect.left + rect.width / 2
    ) {
      cursor.style.setProperty(
        "left",
        "16px",
        "important"
      );

      cursor.style.setProperty(
        "right",
        "auto",
        "important"
      );
    } else {
      cursor.style.setProperty(
        "right",
        "16px",
        "important"
      );

      cursor.style.setProperty(
        "left",
        "auto",
        "important"
      );
    }
  }
);